import React, { useId, useState } from 'react';
import { Eye, EyeOff, LucideIcon } from 'lucide-react';

/**
 * Campo de senha com botao de mostrar e ocultar.
 *
 * Sem ele nao havia como conferir o que foi digitado, e o erro de digitacao so
 * aparecia depois, na hora de entrar. O botao alterna o type do input, entao o
 * gerenciador de senhas do navegador continua reconhecendo o campo.
 */

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  id?: string;
  placeholder?: string;
  required?: boolean;
  minLength?: number;
  autoComplete?: string;
  disabled?: boolean;
  /** Icone desenhado a esquerda, para acompanhar os demais campos do formulario. */
  icone?: LucideIcon;
  /** 'lg' nas telas de acesso, 'md' dentro de modais. */
  tamanho?: 'md' | 'lg';
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
}

const CampoSenha: React.FC<Props> = ({
  icone: Icone, tamanho = 'md', id, ...props
}) => {
  const [visivel, setVisivel] = useState(false);
  const idGerado = useId();
  const idCampo = id ?? idGerado;

  const altura = tamanho === 'lg' ? 'py-3' : 'py-2.5';
  const esquerda = Icone ? 'pl-10' : 'pl-3';

  return (
    <div className="relative">
      {Icone && (
        <Icone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
      )}
      <input
        {...props}
        id={idCampo}
        type={visivel ? 'text' : 'password'}
        className={`w-full ${esquerda} pr-11 ${altura} border border-gray-300 rounded-lg
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500`}
      />
      <button
        type="button"
        onClick={() => setVisivel((v) => !v)}
        // tabIndex -1 mantem o Tab indo do campo de senha direto para o proximo
        // campo do formulario, e nao para o botao de espiar.
        tabIndex={-1}
        aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={visivel}
        aria-controls={idCampo}
        title={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {visivel ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};

export default CampoSenha;
